<template>
  <div class="app-wrapper">
    <div v-if="!loading" class="content">
      <Header></Header>
      <router-view class="view"></router-view>
      <footer id="site-footer" role="contentinfo" class="header-footer-group">
        <div class="section-inner">
          <div class="footer-credits">
            <p class="footer-copyright">©
              2020<a href="https://brewingbeer.io/">brewingbeer.io</a>
            </p><!-- .footer-copyright -->
          </div><!-- .footer-credits -->
        </div><!-- .section-inner -->
      </footer>
    </div>
  </div>
</template>

<script>

  import Dashboard from "./pages/Dashboard.vue";
  import Header from "./components/Header.vue";
  import { HTTP } from "./lib/http";
  import { EventBus } from './lib/event-bus.js';

  export default {
  name: "app",
  data() {
    return {
        loading: true
    };
  },
  methods: {
  },
  beforeMount() {
      EventBus.$on('logged-in', val => {
          vm.$forceUpdate();
      });
  },
  mounted () {
      window.addEventListener('click', event => {
          // ensure we use the link, in case the click has been received by a subelement
          let { target } = event;

          while (target && target.tagName !== 'A') target = target.parentNode;
          // handle only links that do not reference external resources
          if (target && target.matches("a:not([href*='://'])") && target.href) {
              // some sanity checks taken from vue-router:
              // https://github.com/vuejs/vue-router/blob/dev/src/components/link.js#L106
              const { altKey, ctrlKey, metaKey, shiftKey, button, defaultPrevented } = event;
              // don't handle with control keys
              if (metaKey || altKey || ctrlKey || shiftKey) return;
              // don't handle when preventDefault called
              if (defaultPrevented) return;
              // don't handle right clicks
              if (button !== undefined && button !== 0) return;
              // don't handle if `target="_blank"`
              if (target && target.getAttribute) {
                  const linkTarget = target.getAttribute('target');
                  if (/\b_blank\b/i.test(linkTarget)) return
              }
              // don't handle same page links/anchors
              const url = new URL(target.href);
              const to = url.pathname;
              if (window.location.pathname !== to && event.preventDefault) {
                  event.preventDefault();
                  this.$router.push(to)
              }
          }
      });

      if (localStorage.token) {
          HTTP.get('check-user')
              .then(response => {
                  localStorage.username = response.data.data.username;
                  this.loading = false
              })
              .catch(err => {
                  delete localStorage.username;
                  delete localStorage.token;
                  this.loading = false
              })
      } else {
          delete localStorage.username;
          delete localStorage.token;
          this.loading = false;
      }
  },
    components: {
        Dashboard,
        Header
    }
};
</script>

<style lang="scss">
  @import "./assets/scss/_variablesx.scss";
  body {
    font-family: "Roboto", sans-serif;
  }
  body,
  html,
  #app {
    height: 100%;
    background: $body-background;
    min-width: 320px;
  }
  .form-group {
    position: relative;

    .input-unit {
      position: absolute;
      right: 15px;
      text-align: right;
      bottom: 5px;
      opacity: .7;
    }
  }

  ul.is-invalid {
    border: 2px solid #dc3545;
  }

  ul + .invalid-feedback {
    margin-top: -1em;
    margin-bottom: 2em;
  }

  footer {
    .footer-copyright {
      font-weight: 700;
      margin-top: 1em;
      font-size: 18px;
      color: black;

      a {
        margin-left: .3em;
        text-decoration: none;
        color: black;
      }
    }
  }

  @media (max-width: 576px) { //Mobile
    .row > div {
      padding: 0;
      border-radius: 0;

      .card-body,
      .card,
      .row { border-radius: 0; }
    }

    .app-wrapper { width: 100%; }
  }

  @media (min-width: 576px) { //desktop
    .app-wrapper {
      display: flex;
      width: 100%;
      height: 100%;
      align-items: stretch;

      .content {
        padding-left: 15px;
        padding-right: 15px;
        height: 100%;
        overflow: auto;
        flex: 1;

        .view {
          .row:first-child {
            padding-top: 0;
          }
        }

        .row {
          padding-top: 15px;
          padding-bottom: 15px;
        }
      }
    }
  }
</style>
